import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    IconButton,
    Alert
} from '@mui/material';
import {
    Close as CloseIcon,
    Assignment as AssignmentIcon
} from '@mui/icons-material';

export default function TBTInstructionViewModal({ open, onClose, tbtTopic, language = 'english' }) {
    if (!tbtTopic) return null;

    const instructionText = language === 'english' ? tbtTopic.textEnglish : tbtTopic.textSpanish;
    const languageLabel = language === 'english' ? 'English' : 'Spanish';

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle sx={{ py: 2, px: 3, backgroundColor: '#f8f9fa' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <AssignmentIcon sx={{ fontSize: 28, color: '#1976d2' }} />
                        <Box>
                            <Typography variant="h6" fontWeight={600}>Tool Box Talk - {languageLabel}</Typography>
                            <Typography variant="body2" color="text.secondary">
                                For Supervisor Reading
                            </Typography>
                        </Box>
                    </Box>
                    <IconButton onClick={onClose} edge="end">
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>

            <DialogContent sx={{ px: 3, py: 2 }}>
                <Typography variant="h6" gutterBottom fontWeight={600} color="primary">
                    {tbtTopic.title}
                </Typography>

                {instructionText ? (
                    <Box
                        sx={{
                            p: 2,
                            border: '1px solid #e0e0e0',
                            borderRadius: 1,
                            backgroundColor: '#f9f9f9',
                            whiteSpace: 'pre-wrap',
                            fontFamily: 'inherit'
                        }}
                    >
                        <Typography variant="body1">
                            {instructionText}
                        </Typography>
                    </Box>
                ) : (
                    <Alert severity="info">
                        No instruction text available in {languageLabel}
                    </Alert>
                )}
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2 }}>
                <Button onClick={onClose} variant="contained">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}
